import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { Spacing, form, transparentize } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import Tooltip from "@ui-kit/tooltip";
import { tr } from "@radarly/i18n";
import { Cluster } from "@radarly/models/insights";

export interface IProps {
  visibleKeywords: Cluster["keywords"];
  hiddenKeywords: Cluster["keywords"];
  isVisible: boolean;
  locale: Locale;
  onClickBack?: () => void;
}

const Pills = styled.div`
  display: flex;
  gap: ${Spacing.Medium};
  align-items: center;
  height: 32px;
`;

const Pill = styled.div`
  line-height: 32px;
  border-radius: 16px;
  background-color: ${(props) => transparentize(0.85, form(props))};
  color: ${form};
  padding: 0 ${Spacing.Medium};
`;

const TooltipContent = styled.div`
  max-width: 200px;
`;

const StyledButton = styled(Button)`
  border-radius: 16px;
  padding: 0 ${Spacing.Medium};
`;

const ImageClusterKeywords = ({
  isVisible,
  hiddenKeywords,
  visibleKeywords,
  locale,
}: IProps) => {
  return (
    <Pills>
      {isVisible &&
        map(visibleKeywords, (keyword, i) => (
          <Tooltip
            tooltip={
              <TooltipContent>
                {tr(locale, "IMAGE_CLUSTER::TERMS_TOOLTIP")}
              </TooltipContent>
            }
            key={i}
            placement="top"
          >
            <Pill>{keyword}</Pill>
          </Tooltip>
        ))}
      {hiddenKeywords.length > 0 && (
        <Tooltip
          tooltip={
            <TooltipContent>
              <>
                {map(hiddenKeywords, (hiddenKeyword, idx) => (
                  <span key={idx}>
                    {hiddenKeyword}
                    {idx < hiddenKeywords.length - 1 && ", "}
                  </span>
                ))}
              </>
            </TooltipContent>
          }
          placement="top"
        >
          <StyledButton
            variant="tertiary"
            text={`+${hiddenKeywords.length}`}
            size="xs"
          />
        </Tooltip>
      )}
    </Pills>
  );
};

export default ImageClusterKeywords;
